import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getInstallationLocationList as getInstallationLocationListApi,
	getInstallationLocationListQuery as getInstallationLocationListQueryApi,
	getInstallationLocation as getInstallationLocationApi,
	addNewInstallationLocationApi,
	updateInstallationLocationApi,
	deleteInstallationLocationApi,
	checkInstallationLocationExistsApi,
} from '../../helpers/installation_location/api_helper';

export const getInstallationLocationList = createAsyncThunk(
	'installationLocation/getInstallationLocationList',
	async () => {
		try {
			const response = await getInstallationLocationListApi();
			// Extract data array from response
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener las ubicaciones para instalación.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getInstallationLocationListQuery = createAsyncThunk(
	'installationLocation/getInstallationLocationListQuery',
	async params => {
		try {
			const response = getInstallationLocationListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getInstallationLocation = createAsyncThunk(
	'installationLocation/getInstallationLocation',
	async installation_location_id => {
		try {
			const response = await getInstallationLocationApi(installation_location_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener la ubicación para instalación.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewInstallationLocation = createAsyncThunk(
	'installationLocation/addNewInstallationLocation',
	async installation_location => {
		try {
			const response = await addNewInstallationLocationApi(installation_location);
			toast.success('Ubicación Para Instalación agregada exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar la ubicación para instalación.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateInstallationLocation = createAsyncThunk(
	'installationLocation/updateInstallationLocation',
	async installation_location => {
		try {
			const response = await updateInstallationLocationApi(installation_location);
			toast.success('Ubicación Para Instalación actualizada exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar la ubicación para instalación.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteInstallationLocation = createAsyncThunk(
	'installationLocation/deleteInstallationLocation',
	async installation_location => {
		try {
			const response = await deleteInstallationLocationApi(installation_location._id);
			toast.success('Ubicación Para Instalación eliminada exitosamente.', {
				autoClose: 3000,
			});
			// Return the original object to identify which item to remove
			return installation_location;
		} catch (error) {
			toast.error('Error al eliminar la ubicación para instalación.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkInstallationLocationExists = createAsyncThunk(
	'installationLocation/checkInstallationLocationExists',
	async name => {
		try {
			const response = await checkInstallationLocationExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
